import Api from 'api/v2/Api';
import CollectionApi from 'api/v2/CollectionApi';
import axios from 'axios';

class WorkdayApi extends CollectionApi {
  constructor() {
    super('/api/v2/workdays', {
      skip: 0,
      limit: 100,
      sort: 'name',
    });
  }

  /**
   * @description Make the ajax call to authorize a Workday Instance
   * given the username and password.  If the instance already exists,
   * then use the '/api/v2/workdays/{id}/auth' endpoint, otherwise
   * use '/api/v2/workdays'
   */
  authorizeWorkday(id, name, username, password) {
    let url = '/api/v2/workdays';

    return new Promise((resolve, reject) => {
      const mesg = 'An error occurred while attempting to authorize the Workday instance!';

      // If a Workday Instance already exists, call 'auth' endpoint
      if (id) {
        url = `${url}/${id}/auth`;
      }

      this.initialize()
        .then(() => {
          axios
            .post(url, {
              id,
              name,
              auth: {
                basic: {
                  username,
                  password,
                },
              },
            })
            .then(resp => resolve((resp && resp.data) || ''))
            .catch((error) => {
              Api.handleError(
                reject,
                (error.response.data && error.response.data.error) || mesg,
                error,
              );
            });
        })
        .catch((error) => {
          Api.handleError(reject, mesg, error);
        });
    });
  }

  async deauthorizeWorkday(id) {
    await this.initialize();
    const url = `${this.baseUrl}/${id}/auth`;
    return axios.delete(url);
  }

  /**
   * Get all directories and return the ID of the Workday directory.
   * @todo This code assumes there is only _one_ Workday directory instance. If
   * that assumption changes then this method of obtaining the Workday ID will
   * need to be refactored.
   */
  getWorkdayId() {
    return new Promise((resolve, reject) => {
      const mesg = 'Unable to get Workday ID!';
      const params = {
        limit: 100,
        skip: 0,
      };

      this
        .getAllItems('/api/v2/directories', params, mesg)
        .then((directories) => {
          let workdayId = '';

          if (directories && directories.length) {
            directories.forEach((directory) => {
              if (directory.type === 'workday') {
                workdayId = directory.id;
              }
            });
          }

          if (workdayId) {
            resolve(workdayId);
          } else {
            Api.handleError(reject, mesg);
          }
        })
        .catch((error) => {
          Api.handleError(reject, mesg, error);
        });
    });
  }

  /**
   * Given an array of systemUsers make a call to /api/v2/workdays/{id}/import
   * to have the JobService import them into JumpCloud.
   * @param workdayId The id of the Workday Directory instance
   * @param systemUsers An array of system users. See the createSystemUsers()
   * method in the WorkdayWorkerCollection.
   * @returns The id of the batch job from the Job Service.
   */
  import(workdayId, systemUsers) {
    const mesg = 'Unable to import users from Workday!';

    return new Promise((resolve, reject) => {
      this.initialize()
        .then(() => {
          axios
            .post(`/api/v2/workdays/${workdayId}/import`, systemUsers)
            .then((resp) => {
              if (resp && resp.data && resp.data.jobId) {
                resolve(resp.data.jobId);
              } else {
                Api.handleError(reject, mesg);
              }
            })
            .catch((error) => {
              Api.handleError(reject, mesg, error);
            });
        })
        .catch((error) => {
          Api.handleError(reject, mesg, error);
        });
    });
  }
}

export default new WorkdayApi();
